import Event from './Event';
import LocalStorage from '../local_data';

class GetCheckoutStatus extends Event {
    eventName = 'oms_getCheckoutStatus';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for Get checkout status
     * @param {string} data.request_id - optional - unique id for request
     * @param {string} data.action - optional - request action
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';

        if (clientId) {

            let status = new LocalStorage.CheckoutStatus(clientId).getData();

            this.onSuccessEvent({
                data: status
            },  {
                'action' : action, 
                'request_id' : requestId 
            });

        } else {
            //fire error event
            this.onErrorEvent({ "message": "client_id is required", "status": 422 }, {'action' : action, 'request_id' : requestId });
        }
    }
}

export default GetCheckoutStatus;